import { render, staticRenderFns } from "./newHome.vue?vue&type=template&id=31d19fa2&scoped=true&"
import script from "./newHome.vue?vue&type=script&lang=js&"
export * from "./newHome.vue?vue&type=script&lang=js&"
import style0 from "./newHome.vue?vue&type=style&index=0&lang=less&"
import style1 from "./newHome.vue?vue&type=style&index=1&id=31d19fa2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d19fa2",
  null
  
)

export default component.exports